// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.door {
  background-color: gray;
  color: white;
  width: 9rem;
  height: 9rem;
  text-align: center;
  line-height: 9rem;
  font-size: 5rem;
}

.door-enabled {
  background-color: green !important;
  color: white !important;
  width: 9rem;
  height: 9rem;
  text-align: center;
  font-size: 5rem !important;
}

.page-container {
  padding: 5vh;
  height: 80vh;
}

.divider-custom {
  height: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,oDAAoD;EACpD,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.door {\n  background-color: gray;\n  color: white;\n  width: 9rem;\n  height: 9rem;\n  text-align: center;\n  line-height: 9rem;\n  font-size: 5rem;\n}\n\n.door-enabled {\n  background-color: green !important;\n  color: white !important;\n  width: 9rem;\n  height: 9rem;\n  text-align: center;\n  font-size: 5rem !important;\n}\n\n.page-container {\n  padding: 5vh;\n  height: 80vh;\n}\n\n.divider-custom {\n  height: 4rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
